// extracted by mini-css-extract-plugin
module.exports = {"container":"_2m_K9M_GkX-fVgIPEHOYHl","addedItem":"_2LLHYQHLquJJQBdJ8_RsVS","name":"_37Us2ZUpPc2Hn37sfDZqcg","type":"_24FqHVLZtIQc0xhbKhA685","closeIcon":"_13HU2bqVOYIoWmhQrOLlvG"};